/**
 * Created by kfaulhaber on 24/07/2017.
 *
 * Header Class Entity
 */

export class Header {
  constructor(public title: string, public value: string) {}
}
